
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afi9_lnzyz_141",
  "hidden": "awsui_hidden_1afi9_lnzyz_172",
  "no-items": "awsui_no-items_1afi9_lnzyz_175"
};
  